import { HoverCard, HoverCardProps } from '@mantine/core';
import { ITag } from '@models/Tag.model';
import { TagWithDeleteProps } from '@pages/Asset/components/Sidebar/components/Tags/TagWithDelete';
import { TagDialog, useTagDiagStyles } from './TagDialog';
import { PossibleTagsVal, DIALOG_OPEN_DELAY } from './TagDialog.utils';

type TagWDNoHandle = Omit<TagWithDeleteProps, 'onDeleteIconClick'>;

/**
 * Todo: Ideal Case for context, or inherit these props
 */
export interface TagDialogHoverProps<T extends unknown[]> {
  tags: PossibleTagsVal;
  deleteHandlerArgs?: T;
  deleteHandler?: (tag: Pick<ITag, 'id'>, ...args: T) => VoidFunction;

  calcTagProps?: (tag: Pick<ITag, 'id'>) => Partial<TagWDNoHandle>;
  hoverCardProps?: Partial<HoverCardProps>;
  disableDialog?: boolean;
}
type DecoratedTagDialogHoverProps<T extends unknown[]> =
  React.PropsWithChildren<TagDialogHoverProps<T>>;
export function TagDialogHover<T extends unknown[]>(
  props: DecoratedTagDialogHoverProps<T>,
) {
  const { children, tags, hoverCardProps, disableDialog, ...dHandler } = props;
  const { classes: tagDiagC } = useTagDiagStyles();

  const hasTags = tags.length > 0;
  if (disableDialog) {
    return <>{children}</>;
  }
  return hasTags ? (
    <HoverCard
      middlewares={{ shift: true, flip: true }}
      withinPortal
      withArrow
      width={296}
      shadow="md"
      openDelay={DIALOG_OPEN_DELAY}
      {...hoverCardProps}
    >
      <HoverCard.Target>{children}</HoverCard.Target>
      <HoverCard.Dropdown
        className={tagDiagC.dropdown}
        // This stops navigating to product by mistake on inventory page when the dropdown is clicked
        onClick={e => e.stopPropagation()}
      >
        <TagDialog
          rowNum={tags.length}
          tags={tags}
          {...(dHandler as Omit<TagDialogHoverProps<unknown[]>, 'tags'>)}
        />
      </HoverCard.Dropdown>
    </HoverCard>
  ) : (
    // Render empty space by default for places like add manufacturer
    <div> </div>
  );
}
